'use client';

import { cn } from '@/lib/ui/cn';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

/**
 * Styled text input for the intake wizard.
 */
export function TextInput({ className, error, ...props }: TextInputProps) {
  return (
    <input
      className={cn(
        'h-[73px] w-full rounded-[40px] border-2 border-[#F1F0EF] bg-white px-[36px] py-[12px] font-sans text-[21px] leading-[130%] font-normal text-[#292722] transition-colors placeholder:text-[#292722]/50 focus:border-[#292722] focus:outline-none',
        error && 'border-red-500',
        className
      )}
      {...props}
    />
  );
}
